<template>
    <div style="padding: 20px; box-shadow: 3px 3px 10px #aaa; " class="panel">
        <div class="panel-title" style="background-color: #fa6;">
            <h2 style="padding: 10px; margin:0; color: #fff;">
                Find New Tasks
            </h2>
        </div>
        <div id="task-app" class="panel-body">
            <div class="row">
                <div :class="canSearch ? 'col-sm-6 mt-1' : 'col-sm-12 mt-1'">
                    <i class="fa fa-filter"></i> Filter by Task Type
                    <v-select
                        :disabled="this.loading"
                        :clearable="false"
                        v-model="this.selectedActionName"
                        :options="Object.entries(availableActions).map(([key, value]) => {return {label: value, code: key}})"
                        @option:selected="fetchTasks"
                    ></v-select>
                </div>
                <div :class="canSearch ? 'col-sm-6 mt-1' : 'col-sm-12 mt-1'">
                    <i class="fa fa-globe"></i> Only include lessons mapped to
                    <v-select
                        :clearable="true"
                        :value="this.selectedCountryName"
                        :options="allCountries.map(country => {return {label: country.title, code: country.id}})"
                        placeholder="Select a country (optional)"
                        @option:selected="filterByMappedCountry"
                    ></v-select>
                </div>
                <div v-if="canSearch" class="col-sm-12 mt-1">
                    <i class="fa fa-search"></i> Search:
                    <input class="form-control" type="text" id="list_search"
                           data-type="search"
                           v-model="searchQuery"
                           style="border-radius: 0; border: 1px solid #ccc"
                           :placeholder="'Search '+selectedAction+' tasks'"/>
                </div>
            </div>
            <br/>


            <br/>
            <div v-if="loading" align="center" style="height: 450px; padding-top: 120px">
                <i class="fa fa-spinner fa-spin fa-4x"></i>
            </div>

            <div id="searchable-tasks" v-if="!loading"
                 style="height: 450px; overflow-y: auto; overflow-x: hidden;">
                <h3>Results</h3>
                <div>
                  <template v-for="(task, idx) in tasks" :key="'task-'+task.id">
                    <assignable-task
                      ref="tasks"
                      :task="task"
                      :userId="userId"
                      :csrf="csrfToken"
                      v-if="taskMatchesSearch(task, searchQuery) && lessonMappedToSelectedCountry(task)"
                      @clicked="assignTask(idx)"
                    ></assignable-task>
                  </template>
                </div>
                <div v-if="tasks.filter(task => {return taskMatchesSearch(task, searchQuery) && lessonMappedToSelectedCountry(task)}).length === 0"
                   class="text-center"
                >
                    - No tasks -
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.vs__search, .vs__open-indicator, .vs__dropdown-toggle, .v-select {
  cursor: pointer !important;
}
</style>

<script>
    export default {
        props: [
            'userId',
            'availableActions',
            'csrfToken',
            'fetchRunningTasks',
            'fetchCurrentTasksAndProjectedEarnings',
            'canSearch',
            'countries'
        ],

        data() {
            return {
                tasks: [],
                loading: true,
                searchQuery: '',
                selectedActionId: Object.keys(this.availableActions)[0],
                selectedActionName: Object.values(this.availableActions)[0],
                selectedCountryName: '',
                allCountries: JSON.parse(this.countries),
                mappedLessons: null,
            };
        },

        mounted: function() {
            if (Object.keys(this.availableActions)[0] !== undefined) {
              const firstAvailableAction = Object.entries(this.availableActions)[0]
                this.fetchTasks({
                  label: firstAvailableAction[1],
                  code: firstAvailableAction[0],
                });
            }
        },

        computed: {
            selectedAction: function() {
                if (this.selectedActionId in this.availableActions) {
                    return this.availableActions[this.selectedActionId];
                }
            },
        },

        methods: {
            fetchTasks: function(value) {
                const actionId = value.code;
                this.loading = this.loading || this.selectedActionId !== actionId;
                this.selectedActionId = actionId;
                this.selectedActionName = value.label;

                fetch('/user/' + this.userId + '/assignableTasks?action_id=' + actionId)
                .then(response => response.json())
                .then(response => {
                    this.tasks = response;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    window.alert('ERROR:\n' + error);
                    console.dir(error);
                });
            },

            filterByMappedCountry: function (value) {
                if (!value) {
                  this.mappedLessons = null
                  this.selectedCountryName = ''
                  return
                }

                this.selectedCountryName = value.label

                fetch(`/api/countries/${value.code}/mappedLessonCodes`).then(response => response.json())
                .then(response => {
                  this.mappedLessons = response
                })
            },

            taskMatchesSearch: function(task, searchQuery) {
              searchQuery = searchQuery.toLowerCase().split(' ')
              let match = true
              searchQuery.forEach(function (word) {
                if (word !== '') {
                  let search = ((task.lessonCode || '') + ' ' + task.lessonTitle + ' ' + task.language + ' ' + task.country).toLowerCase()
                  if (!search.includes(word)) {
                    match = false
                  }
                }
              })

              return match
            },

            lessonMappedToSelectedCountry: function (task) {
              if (!this.mappedLessons) {
                return true
              }

              //include tasks that don't have a lessonCode because of concepts-translations
              return !task.lessonCode || this.mappedLessons.includes(task.lessonCode)
            },

            assignTask(idx) {
                // remove the newly assigned task from the stored tasks array
                this.$refs.tasks.splice(idx, 1);
                this.tasks.splice(idx, 1);
                this.fetchRunningTasks();
                this.fetchCurrentTasksAndProjectedEarnings();

                if (this.tasks.length === 0) {
                    this.loading = true
                    this.fetchTasks({
                      label: this.selectedActionName,
                      code: this.selectedActionId
                    })
                }
            },
        },
    };
</script>
